"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// a basic component that includes a file input and the ability to render anything as the button.
// the input is accessed in the parent via the forwardedRef
var BasicPDFInput = function BasicPDFInput(_ref) {
  var handlePDFSelect = _ref.handlePDFSelect,
      forwardedRef = _ref.forwardedRef,
      _ref$renderButton = _ref.renderButton,
      renderButton = _ref$renderButton === void 0 ? function () {} : _ref$renderButton;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "basic-pdf-input"
  }, renderButton(), /*#__PURE__*/_react.default.createElement("input", {
    ref: forwardedRef,
    onChange: handlePDFSelect,
    type: "file",
    accept: "application/pdf",
    style: {
      display: 'none'
    }
  }));
};

var func = _propTypes.default.func,
    object = _propTypes.default.object;
BasicPDFInput.propTypes = {
  handlePDFSelect: func,
  forwardedRef: object.isRequired,
  renderButton: func
};
var _default = BasicPDFInput;
exports.default = _default;